import App from './App.vue';
import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import { router } from '@/routes/index.js';

import vuePlugins from './composables/vuePlugins';
import general from './composables/generalComponents.js';

import '@/assets/scss/main.scss';

const app = createApp(App);

vuePlugins.forEach((plugin) => {
  app.use(plugin.app, plugin.option);
});

general.components.forEach((component) => {
  app.component(component.name, component.component);
});

app.mount('#app');

if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', import.meta.env.VITE_API_SERVER_URL],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
      new Sentry.Replay()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

console.log(
  '%c Customer Data Platform - Client %c Finish %c',
  'background: #0c7890 ; padding: 2px; border-radius: 3px 0 0 3px;  color: #fff',
  'background: #14c8c8 ; padding: 2px; border-radius: 0 3px 3px 0;  color: #111',
  'background:transparent'
);
